export default __webpack_public_path__ + "static/media/p16.01e38525.jpg";